import { useState } from "react";
import commercialImg from "@/assets/commercial-v2.jpg";
import grindingImg from "@/assets/grinding-v2.jpg";
import metallicBasementImg from "@/assets/metallic-v3.jpg";
import flakeTanImg from "@/assets/project-flake-tan.jpg.asset.json";
import flakeGlossyImg from "@/assets/project-flake-glossy.jpg.asset.json";
import flakeBlueImg from "@/assets/project-flake-blue.jpg.asset.json";
import garageGreyImg from "@/assets/project-garage-grey.jpg.asset.json";
import broadcastImg from "@/assets/project-broadcast.png.asset.json";
import flakeRollerImg from "@/assets/img_6313.jpg.asset.json";
import garageStorageImg from "@/assets/img_6422.jpg.asset.json";
import kitchenFlakeImg from "@/assets/img_6379.jpg.asset.json";
import garageStairsImg from "@/assets/img_6508.jpg.asset.json";

import flakeTan800 from "@/assets/project-flake-tan-800.webp.asset.json";
import flakeTan1600 from "@/assets/project-flake-tan-1600.webp.asset.json";
import commercial800 from "@/assets/commercial-800.webp.asset.json";
import commercial1600 from "@/assets/commercial-1600.webp.asset.json";
import flakeGlossy800 from "@/assets/flake-glossy-800.webp.asset.json";
import flakeGlossy1600 from "@/assets/flake-glossy-1600.webp.asset.json";
import garageGrey800 from "@/assets/garage-grey-800.webp.asset.json";
import garageGrey1600 from "@/assets/garage-grey-1600.webp.asset.json";
import grinding800 from "@/assets/grinding-800.webp.asset.json";
import grinding1600 from "@/assets/grinding-1600.webp.asset.json";
import flakeBlue800 from "@/assets/flake-blue-800.webp.asset.json";
import flakeBlue1600 from "@/assets/flake-blue-1600.webp.asset.json";
import broadcast800 from "@/assets/broadcast-800.webp.asset.json";
import broadcast1600 from "@/assets/broadcast-1600.webp.asset.json";
import metallicBasement800 from "@/assets/metallic-basement-800.webp.asset.json";
import metallicBasement1600 from "@/assets/metallic-basement-1600.webp.asset.json";
import flakeRoller800 from "@/assets/flake-roller-800.webp.asset.json";
import flakeRoller1600 from "@/assets/flake-roller-1600.webp.asset.json";
import garageStorage800 from "@/assets/garage-storage-800.webp.asset.json";
import garageStorage1600 from "@/assets/garage-storage-1600.webp.asset.json";
import kitchenFlake800 from "@/assets/kitchen-flake-800.webp.asset.json";
import kitchenFlake1600 from "@/assets/kitchen-flake-1600.webp.asset.json";
import garageStairs800 from "@/assets/garage-stairs-800.webp.asset.json";
import garageStairs1600 from "@/assets/garage-stairs-1600.webp.asset.json";

import { SectionHeading } from "./SectionHeading";
import { Lightbox } from "./Lightbox";

const PROJECTS = [
  { fallback: flakeTanImg.url, webp800: flakeTan800.url, webp1600: flakeTan1600.url, title: "Flake epoxy garage", location: "Calgary" },
  { fallback: commercialImg, webp800: commercial800.url, webp1600: commercial1600.url, title: "Commercial showroom", location: "Calgary" },
  { fallback: flakeGlossyImg.url, webp800: flakeGlossy800.url, webp1600: flakeGlossy1600.url, title: "Glossy flake garage", location: "Calgary" },
  { fallback: garageGreyImg.url, webp800: garageGrey800.url, webp1600: garageGrey1600.url, title: "Triple-car garage", location: "Calgary" },
  { fallback: grindingImg, webp800: grinding800.url, webp1600: grinding1600.url, title: "Patio Deck", location: "Airdrie" },
  { fallback: flakeBlueImg.url, webp800: flakeBlue800.url, webp1600: flakeBlue1600.url, title: "Orbit flake garage", location: "Calgary" },
  { fallback: broadcastImg.url, webp800: broadcast800.url, webp1600: broadcast1600.url, title: "Flake broadcast install", location: "Calgary" },
  { fallback: metallicBasementImg, webp800: metallicBasement800.url, webp1600: metallicBasement1600.url, title: "Commercial office", location: "Silver Spring" },
  { fallback: flakeRollerImg.url, webp800: flakeRoller800.url, webp1600: flakeRoller1600.url, title: "Polyaspartic topcoat in progress", location: "Calgary" },
  { fallback: garageStorageImg.url, webp800: garageStorage800.url, webp1600: garageStorage1600.url, title: "Tan flake garage with storage", location: "Calgary" },
  { fallback: kitchenFlakeImg.url, webp800: kitchenFlake800.url, webp1600: kitchenFlake1600.url, title: "Commercial kitchen flake floor", location: "Calgary" },
  { fallback: garageStairsImg.url, webp800: garageStairs800.url, webp1600: garageStairs1600.url, title: "Garage with coved base", location: "Calgary" },
];

const GRID_SIZES = "(min-width: 1024px) 25vw, (min-width: 640px) 33vw, 33vw";

export function ProjectsGallery() {
  const [lightboxIdx, setLightboxIdx] = useState<number | null>(null);
  const images = PROJECTS.map((p) => ({
    src: p.fallback,
    alt: `${p.title} — ${p.location}`,
    caption: `${p.title} — ${p.location}`,
  }));
  return (
    <section className="section-light section-ivory border-y border-border py-20 md:py-28">
      <div className="container-x">
        <SectionHeading
          eyebrow="Recent Projects"
          title="Floors We&rsquo;ve Recently Transformed."
          body="A look at recent epoxy and polyaspartic coating projects across Calgary and surrounding areas."
        />
        <div className="mt-12 grid gap-2 grid-cols-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {PROJECTS.map((p, i) => (
            <figure key={i} className="group relative overflow-hidden border border-border bg-charcoal">
              <button
                type="button"
                onClick={() => setLightboxIdx(i)}
                aria-label={`Open ${p.title} — ${p.location} in lightbox`}
                className="block w-full cursor-zoom-in focus:outline-none focus:ring-2 focus:ring-copper"
              >
                <picture>
                  <source
                    type="image/webp"
                    srcSet={`${p.webp800} 800w, ${p.webp1600} 1600w`}
                    sizes={GRID_SIZES}
                  />
                  <img
                    src={p.fallback}
                    alt={`${p.title} — ${p.location}`}
                    width={1200}
                    height={1200}
                    className="aspect-square w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading={i === 0 ? "eager" : "lazy"}
                    fetchPriority={i === 0 ? "high" : undefined}
                    decoding={i === 0 ? undefined : "async"}
                  />
                </picture>
              </button>
              <figcaption className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-jet/95 via-jet/60 to-transparent p-3.5 text-xs font-medium leading-snug text-silver-light">
                {p.title}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
      {lightboxIdx !== null && (
        <Lightbox
          images={images}
          index={lightboxIdx}
          onClose={() => setLightboxIdx(null)}
          onIndexChange={setLightboxIdx}
        />
      )}
    </section>
  );
}
